export default __webpack_public_path__ + "assets/images/7c4711bac92078dde8be157208599314.jpg";